import React from 'react'
import {useDeleteModal} from "../../../context/DeleteModalContext";
import {Link} from "react-router-dom";
import {KTIcon} from "../../../../_metronic/helpers";
import moment from "moment";
import {MODERATOR_FAQ} from "../../../mock/URLs";
import {IQuestionItem} from "../../../types/question";

type QuestionCardType = {
  question: IQuestionItem,
  refetchQuestions: () => void
}

export const QuestionCard = ({question, refetchQuestions}: QuestionCardType) => {
  const {openDeleteModal} = useDeleteModal()

  const handleDeleteClick = (id: number) => {
    openDeleteModal(MODERATOR_FAQ, id, refetchQuestions);
  };

  return (
      <div className={"mb-5"} key={question?.id}>
        <div className="card">
          <div className={"p-5 rounded-4 row"}>
            <div className={"col-md-10"}>
              <div>
                <span className={"badge badge-light-primary"}>{question?.category?.name}</span>
                <h1 className={"fs-2 text-truncate my-3"}>{question?.title}</h1>
                <div className={"text-muted text-truncate"} dangerouslySetInnerHTML={{__html: question?.description}}/>
                <p className="text-muted mb-0 fs-7">{moment(question?.created_at).format("DD.MM.YYYY HH:ss")}</p>
              </div>
            </div>
            <div className={"col-md-2"}>
              <Link to={`/questions/update/${question?.id}`} className={"btn btn-sm btn-light-primary w-100"}>
                <KTIcon iconName={"pencil"} className={"fs-4"}/>
                Tahrirlash
              </Link>
              <button onClick={() => handleDeleteClick(question?.id)} className="btn btn-danger btn-sm w-100 mt-2">
                <KTIcon iconName={"trash-square"} className={"fs-3"}/>
                O'chirish
              </button>
            </div>
          </div>
        </div>
      </div>
  )
}
